import { Card, CardContent } from '@material-ui/core';
import React from 'react';
import AwardsAndAwaitingItem from './AwardsAndAwaitingItem';
import PoOffersEmptyState from './PoOffersEmptyState';
import ReOfferItem from './ReOfferItem';
import './PoOffersBox.scss';
import { dataFormatting } from '../../_lib/lib';
import { reofferRule } from '../PreOrders/Utils';
import { IPooffersItems } from '../../types/IPoOffers';

interface IPoofferBox {
  currentTab: string;
  deleteItem: (item: IPooffersItems, offerId: number[]) => {};
  exportOfferSheet: () => {};
  importOfferSheet: () => void;
  isFiltered?: boolean;
  offersList: any;
  updateItem: (item: IPooffersItems) => {};
}

const PoOffersBox = (props: IPoofferBox) => {
  const { currentTab, offersList, deleteItem, updateItem } = props;

  if (Object.keys(offersList).length === 0) return <PoOffersEmptyState {...props} />;

  return (
    <div className="grid-x cell small-12 px-po-cards">
      {Object.keys(offersList).map((warehouseCode: string) => {
        return (
          <Card
            id={`warehouse-${warehouseCode}`}
            key={`${currentTab}-warehouse-${warehouseCode}`}
            className="cell small-12 margin-bottom-1 px-po-offers-card">
            <CardContent>
              <div className="grid-x cell small-12 px-po-card-header">
                <h5 className="cell small-12 px-po-offers-card-title faded_1 bold margin-left-1">
                  Warehouse {warehouseCode}
                </h5>
                <span className="grid-x cell small-12 text-right margin-bottom-2">
                  <span className="cell small-9 faded_1 px-po-offers-card-subtotal">
                    Subtotal for Warehouse {warehouseCode} :{' '}
                    <span className="totalVal">
                      {dataFormatting('currency', offersList[warehouseCode].subTotal)}
                    </span>
                  </span>
                  <span className="cell small-3 text-center px-large-align-right"></span>
                </span>
              </div>
              <div className="grid-x">
                {reofferRule(currentTab)
                  ? offersList[warehouseCode].items.map((item: IPooffersItems, idx: number) => {
                      return (
                        <ReOfferItem
                          item={item}
                          key={`${currentTab}-${item.offerId}`}
                          deleteItem={deleteItem}
                          updateItem={updateItem}
                        />
                      );
                    })
                  : offersList[warehouseCode].items.map((item: IPooffersItems, idx: number) => {
                      return (
                        <AwardsAndAwaitingItem
                          item={item}
                          key={`${currentTab}-${item.offerId}`}
                          currentTab={currentTab}
                          deleteItem={deleteItem}
                        />
                      );
                    })}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default PoOffersBox;
